export default {
	methods: {
		isDarkColor (color) {
			if (color.includes('lighten')) {
				return false
			}

			const colorWords = color.split(' ')
			const darkStrings = ['darken', 'purple', 'red', 'pink', 'indigo']

			return darkStrings.some(item => colorWords.some(word => word.indexOf(item) !== -1))
		}
	}
}
